module.exports = __webpack_public_path__ + "files/3d663e1faf5409a8535dd83507761efc.svg";